export default __webpack_public_path__ + "static/media/Gray-Line.87067ce7.svg";